import { CustomDialog } from '../../components/CustomDialog';
import { useState } from 'react';
import { Button, InputController } from '../../components';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import { useUploadInvoiceMutation } from '../../services/orders';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import { UploadFileController } from '../../components/formControllers/uploadFile';
import { TButtonVariant } from '../../types';

const formSchema = yup.object({
  invoiceNumber: yup
    .string()
    .required('please enter invoice number'),
  uploadFile: yup
    .mixed()
    .required('please upload invoice file')
    .test(
      'fileSize',
      'Please attach image size upto 500KB',
      (file) => {
        if (!file) return true;
        return (file as File)?.size <= 500 * 1000;
      }
    ),
});
type TFormData = yup.InferType<typeof formSchema>;

export const UploadInvoice: React.FC<{
  orderId: number;
  buttonVeriant?: TButtonVariant;
}> = ({
  orderId,
  buttonVeriant = 'button--quaternary',
}) => {
  const {
    formState: { errors },
    handleSubmit,
    register,
    setValue,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [importAction] = useUploadInvoiceMutation();

  const onImportClick = (formData: TFormData) => {
    setOpen(false);
    const data = new FormData();
    data.append('file', formData.uploadFile as File);
    data.append('invoiceNumber', formData.invoiceNumber);
    importAction({ data, orderId })
      .unwrap()
      .then(() => {
        dispatch(
          showAlert({
            content: 'Invoice Uploaded Successfully',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant={buttonVeriant}>
        <div className="text-xs">Upload Invoice</div>
      </Button>
      <CustomDialog
        isForm
        dialogTitle="Upload Invoice"
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit(onImportClick)}
        actionText={{ submit: 'Save', cancel: 'Cancel' }}
        maxWidth="sm">
        <>
          <InputController
            label="Invoice Number"
            placeholder="Enter Invoice Number"
            register={register('invoiceNumber')}
            error={errors.invoiceNumber?.message}
            required
          />
          <UploadFileController
            label="Upload file"
            allowedMediaTypes="image/png, image/jpeg, .pdf"
            handleFile={(file) =>
              setValue('uploadFile', file)
            }
            required
            error={errors?.uploadFile?.message}
          />
          <div className="td-value--light -mt-6">
            {`328 x 140 | png, jpeg, PDF | < 500kb`}
          </div>
        </>
      </CustomDialog>
    </>
  );
};
